var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B9E0082-D7EF-4A59-9967-2C6E81F3F17A_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid",
    transform: "translate(-1207.000000, -99.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Search",
    transform: "translate(1208.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,11 L24.2,24.2",
    id: "Path-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFCD00",
    cx: 9.6,
    cy: 9.6,
    r: 9.6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/Icon_Search.8eeacbdef8705328548b2d96b2d8d236.svg";
export { ForwardRef as ReactComponent };